import * as Yup from 'yup';

import { getValidationRules } from '../../utils/validation';
// @ts-ignore
import general from './content.json';

export const validation = Yup.object().shape({
  ...getValidationRules(general)
});
